import { v7 as uuid } from 'uuid';
import { ObjectUUId, ReadableObjectUUId } from '../dto/common.dto';

export function generateObjectUUId<T>(): T {
  return <T>uuid();
}

export function uuidToReadable(objectId: ObjectUUId<any>, characterBase = 36): ReadableObjectUUId<any> {
  return <ReadableObjectUUId<any>>BigInt(`0x${ objectId.replace(/-/g, '') }`).toString(characterBase);
}

export function readableToUUID<T>(readable: ReadableObjectUUId<any>, characterBase = 36): ObjectUUId<T> | undefined {
  if (!readable) {
    return undefined;
  }

  try {
    const numberValue: bigint = Array.from(readable)
      .reduce((r, v) => r * BigInt(characterBase) + BigInt(parseInt(v, characterBase)), 0n);

    let hex = numberValue.toString(16);

    if (hex.length % 2) {
      hex = '0' + hex;
    }

    const length = hex.length / 2;

    const u8 = new Uint8Array(length);

    let i = 0;
    let j = 0;
    while (i < length) {
      u8[i] = parseInt(hex.slice(j, j + 2), 16);
      i += 1;
      j += 2;
    }

    return <ObjectUUId<T>>Array.from(u8)
      .map((b) => ('00' + b.toString(16)).slice(-2))
      .join('')
      .replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
  } catch {

  }

  return undefined;
}